import breakpoints from '@/assets/styles/variables/_breakpoints.scss'
import _ from 'lodash'

const state = {
  breakpoints: {
    'to-small': false,
    'small': false,
    'to-medium': false,
    'medium': false,
    'to-large': false,
    'large': false,
    'to-x-large': false,
    'x-large': false
  },
  isPortrait: true
}

const mutations = {
  set_responsive_data(state, payload) {
    _.set(state, payload.path, payload.value)
  }
}

const actions = {
  subscribeToResponsiveEvents({ commit }) {
    _.forOwn(breakpoints, (mediaQuery, key) => {
      const mql = window.matchMedia(mediaQuery)
      const callback = ({ matches }) => {
        commit('set_responsive_data', { path: ['breakpoints', key], value: matches })
      }
      mql.addListener(callback)
      callback(mql)
    })

    const mql = window.matchMedia('(orientation: portrait)')
    commit('set_responsive_data', { path: 'isPortrait', value: mql.matches })

    mql.addListener(m => {
      commit('set_responsive_data', { path: 'isPortrait', value: m.matches })
    })
  }
}

const getters = {
  breakpoints: state => state.breakpoints,
  screenOrientation: state => state.screenOrientation
}

export default {
  state,
  getters,
  actions,
  mutations
}
